import { CommonResType, PagingReq } from 'types/common.type';
import { AxiosGW } from './axios.service';

export const getListAvailableRoom = async (payload: PagingReq) => {
  const { limit, page } = payload;

  return AxiosGW.get('/api/v1/property/rooms/booking', {
    params: { limit, page },
    isDisableLoading: true,
    isDisableToast: true,
  });
};

export const getListAvailableRoomInBuilding = async (payload: PagingReq & CommonResType) => {
  const { limit, page, buildingId } = payload;

  return AxiosGW.get(`/api/v1/property/building/${buildingId}/rooms/booking`, {
    params: { limit, page },
    isDisableLoading: true,
    isDisableToast: true,
  });
};

export const getListPartner = async () => {
  return AxiosGW.get('/api/v1/property/branches', {
    isDisableLoading: true,
    isDisableToast: true,
  });
};

export const getPartnerDetail = async (payload: CommonResType) => {
  const { branchId } = payload;

  return AxiosGW.get(`/api/v1/property/branch/${branchId}/detail`, {
    isDisableLoading: true,
    isDisableToast: true,
  });
};

export const getRoomDetail = async (payload: CommonResType) => {
  const { roomId } = payload;

  return AxiosGW.get(`/api/v1/property/room/${roomId}/detail`, {
    isDisableLoading: true,
    isDisableToast: true,
  });
};

export const getBuildingDetail = async (payload: CommonResType) => {
  const { buildingId, branchId } = payload;

  return AxiosGW.get(`/api/v1/property/branch/${branchId}/building/${buildingId}/detail`, {
    isDisableLoading: true,
    isDisableToast: true,
  });
};
